let LocalizationFooter = {
    "en": {
        follow: 'Follow Us',
        TitleQuickLinks: 'quick links',
        QuickLinks: [
            { path: '/home', pathAr: '/ar/الصفحة-الرئيسية', text: 'Home' },
            { path: '/about-us', pathAr: '/ar/نبذة-عنا', text: 'about us' },
            { path: '/projects', pathAr: '/ar/مشاريعنا', text: 'portfolio' },
            { path: '/clients', pathAr: '/ar/عملائنا', text: 'our client' },
            { path: '/blogs', pathAr: '/ar/المدونات', text: 'blogs' },
            { path: '/jobs', pathAr: '/ar/وظائف', text: 'career ' },
        ],
        TitleService: 'Service',
        service: [
            { path: '/en/branding', pathAr: '/ar/العلامات-التجارية', text: 'Branding', type: 'branding' },
            { path: '/en/website-development', pathAr: '/ar/تطوير-الموقع', text: 'Website Development', type: 'Web Development' },
            { path: '/en/social-media-marketing', pathAr: '/ar/تسويق-وسائل-الاعلام-الاجتماعية', text: 'Digital Marketing', type: 'web' },
            { path: '/en/content-marketing', pathAr: '/ar/تسويق-المحتوى', text: 'Content Marketing ', type: 'mobilApp' },
            { path: '/en/visual-production', pathAr: '/ar/الإنتاج-المرئي', text: 'Visual Production', type: 'digitalMarketing' },
         ],
        TitleContactUS: 'Contact Us'
    },

    "ar": {
        follow: ' تــابعنــا هـــــنا',
        TitleQuickLinks: 'تنقل سريع',

        QuickLinks: [
            { path: '/home', pathAr: '/ar/الصفحة-الرئيسية', text: 'الرئيسيه' },
            { path: '/about-us', pathAr: '/ar/نبذة-عنا', text: '  من نحن' },
            { path: '/projects', pathAr: '/ar/مشاريعنا', text: 'أعمالنا' },
            { path: '/clients', pathAr: '/ar/عملائنا', text: 'عملائنا  ' },
            { path: '/blogs', pathAr: '/ar/المدونات', text: 'مقالات' },
            { path: '/jobs', pathAr: '/ar/وظائف', text: 'وظائفنا  ' },
        ],
        TitleService: 'خدماتنا',
        service: [
            'التسويق الرقمي',
            "الإنتاج الظاهري",
            "تنظيم الأحداث",
            "تطوير المواقع الالكترونيه ",
            "هوية بصرية"
        ],

        service: [ 

            { path: '/en/branding', pathAr: '/ar/العلامات-التجارية', text: 'العلامات التجارية', type: 'branding' },
            { path: '/en/website-development', pathAr: '/ar/تطوير-الموقع', text: 'تطوير الموقع', type: 'Web Development' },
            { path: '/en/social-media-marketing', pathAr: '/ar/تسويق-وسائل-الاعلام-الاجتماعية', text: ' التسويق الرقمي ', type: 'web' },
            { path: '/en/content-marketing', pathAr: '/ar/تسويق-المحتوى', text: 'تسويق المحتوى', type: 'mobilApp' },
            { path: '/en/visual-production', pathAr: '/ar/الإنتاج-المرئي', text: 'الإنتاج المرئي', type: 'digitalMarketing' },

        ],
        TitleContactUS: 'أتصل بنا',
    }
}

export default LocalizationFooter